'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _getSize = require('../../../helpers/getSize');

var _getSize2 = _interopRequireDefault(_getSize);

var _sizes = require('../../../constants/sizes');

var _colors = require('../../../constants/colors');

var _layout = require('../layout');

var _layout2 = _interopRequireDefault(_layout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DefaultIcon = function DefaultIcon(props) {
    return _react2.default.createElement(
        'svg',
        props,
        _react2.default.createElement(
            'defs',
            null,
            _react2.default.createElement('path', {
                id: 'a',
                d: 'M0 58.224h59.604V.177H0z'
            })
        ),
        _react2.default.createElement(
            'g',
            {
                fill: 'none',
                fillRule: 'evenodd'
            },
            _react2.default.createElement(
                'g',
                {
                    fill: '#FFCF3F'
                },
                _react2.default.createElement('path', {
                    d: 'M55.298 46.03l-6.47-3.736 1.245-2.157 6.47 3.736zM52.463 31.212h7.472v-2.49h-7.472zM50.072 19.798l-1.245-2.157 6.47-3.736 1.246 2.157zM9.862 19.798l-6.47-3.736 1.245-2.157 6.47 3.736zM0 31.212h7.471v-2.49H0zM4.637 46.03l-1.245-2.157 6.47-3.736 1.245 2.157zM28.722 7.47h2.49V0h-2.49zM17.64 11.108l-3.736-6.47 2.157-1.246 3.736 6.47zM16.062 56.543l-2.157-1.246 3.736-6.47 2.156 1.245zM28.722 59.935h2.49v-7.472h-2.49zM43.873 56.543l-3.736-6.47 2.157-1.246 3.736 6.47zM42.294 11.108l-2.156-1.246 3.735-6.47 2.157 1.245z'
                })
            ),
            _react2.default.createElement(
                'g',
                {
                    transform: 'translate(0 .172)'
                },
                _react2.default.createElement('path', {
                    d: 'M21.46 21.612l4.314 6.51c.01.016 4.312 10.647 4.386 12.096l4.693-11.775s4.197-6.624 4.244-6.624H31.04l3.204 6.301-7.682-.046s4.233-6.252 3.905-6.255c-4.593-.054-9.007-.207-9.007-.207',
                    fill: '#A7F2EB'
                }),
                _react2.default.createElement('path', {
                    d: 'M17.811 28.784l12.468 11.69 12.467-11.69v-.995l-3.548-5.657H21.36L17.81 27.79v.995zM30.28 42.606L16.253 29.453v-2.11l4.243-6.764h19.565l4.244 6.764v2.11L30.279 42.606z',
                    fill: '#3F5060'
                }),
                _react2.default.createElement(
                    'mask',
                    {
                        id: 'b',
                        fill: '#fff'
                    },
                    _react2.default.createElement('use', {
                        xlinkHref: '#a'
                    })
                ),
                _react2.default.createElement('path', {
                    fill: '#3F5060',
                    mask: 'url(#b)',
                    d: 'M17.032 29.119h26.494v-1.553H17.032z'
                }),
                _react2.default.createElement('path', {
                    fill: '#3F5060',
                    mask: 'url(#b)',
                    d: 'M29.544 41.798L24.87 28.601l1.47-.517 4.675 13.197z'
                }),
                _react2.default.createElement('path', {
                    fill: '#3F5060',
                    mask: 'url(#b)',
                    d: 'M31.013 41.798l-1.47-.517 4.547-12.83-4.46-6.665 1.297-.861 4.892 7.31zM24.955 28.773l-4.675-6.987 1.296-.86 4.676 6.986z'
                }),
                _react2.default.createElement('path', {
                    fill: '#3F5060',
                    mask: 'url(#b)',
                    d: 'M35.602 28.773l-1.296-.861 4.675-6.987 1.297.861zM26.287 29l-1.33-.892 4.858-7.186 1.33.892z'
                })
            )
        )
    );
};

DefaultIcon.defaultProps = {
    width: '60',
    height: '60',
    viewBox: '0 0 60 60',
    xmlns: 'http://www.w3.org/2000/svg',
    xmlnsXlink: 'http://www.w3.org/1999/xlink'
};

var ProfileIcon = function (_React$Component) {
    _inherits(ProfileIcon, _React$Component);

    function ProfileIcon() {
        _classCallCheck(this, ProfileIcon);

        return _possibleConstructorReturn(this, (ProfileIcon.__proto__ || Object.getPrototypeOf(ProfileIcon)).apply(this, arguments));
    }

    _createClass(ProfileIcon, [{
        key: 'render',
        value: function render() {
            var size = this.props.size || _sizes.Sizes.md;
            size = (0, _getSize2.default)(size);
            return _react2.default.createElement(
                _layout2.default,
                this.props,
                _react2.default.createElement(DefaultIcon, { fill: this.props.hover || this.props.active ? _colors.Colors.calmWhite : _colors.Colors.claimBlack, width: size + 'px', height: size + 'px' })
            );
        }
    }]);

    return ProfileIcon;
}(_react2.default.Component);

exports.default = ProfileIcon;